import { useState } from "react";

import SisiAvatar from "./SisiAvatar";
import SisiChatPanel from "./SisiChatPanel";

export default function SisiFloatingButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="
            fixed bottom-5 right-5 z-[60]
            group flex h-[54px] w-[54px]
            items-center justify-center
            rounded-full border border-primary/20
            bg-background p-1.5
            shadow-[0_10px_28px_rgba(0,0,0,0.16)]
            transition-all duration-200
            hover:-translate-y-0.5
            hover:border-primary/35
            hover:shadow-[0_14px_34px_rgba(0,0,0,0.20)]
          "
          data-testid="sisi-floating-button"
          aria-label="Falar com a Sisi"
          title="Falar com a Sisi"
        >
          <SisiAvatar size="md" online />
        </button>
      )}

      <SisiChatPanel
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
